<div class="customer-ratings">
  <div class="customer-ratings__header">
    <h3 class="customer-ratings__title">
      Kundenbewertungen zur {{ bankName }}
    </h3>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="customer-ratings__loading">
    <div class="skeleton-box">
      <div class="skeleton-box__header"></div>
      <div class="skeleton-box__content">
        <div class="skeleton-box__row"></div>
        <div class="skeleton-box__row"></div>
        <div class="skeleton-box__row short"></div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError && !isLoading" class="customer-ratings__error">
    <p>Fehler beim Laden der Kundenbewertungen.</p>
  </div>

  <!-- Content -->
  <div
    *ngIf="!isLoading && !hasError && ratingsData"
    class="customer-ratings__content"
  >
    <div class="customer-ratings__summary">
      <div class="summary__stars">
        <div class="stars__display">
          <app-star-rating
            [rating]="averageRating"
            size="medium"
          ></app-star-rating>
        </div>
        <div class="stars__rating">
          <span class="rating__score">{{ averageRating }}</span>
          <span class="rating__max">von <strong>5 Sternen</strong></span>
          <span class="rating__count">({{ totalReviews }} Bewertungen)</span>
        </div>
      </div>
    </div>

    <div class="customer-ratings__description">
      <p>
        Es haben {{ totalReviews }} Kunden, welche über CHECK24 beantragt haben,
        die {{ bankName }} bewertet:
      </p>
    </div>

    <div class="customer-ratings__breakdown">
      <div *ngFor="let rating of ratingBreakdown; trackBy: trackByStars" class="breakdown__row">
        <div class="row__label">
          {{ rating.label }}
        </div>
        <div class="row__bar">
          <div class="bar__container">
            <div
              class="bar__fill"
              [style.width.%]="getRatingPercentage(rating.count)"
            ></div>
          </div>
        </div>
        <div class="row__count">
          {{ rating.count }}
        </div>
      </div>
    </div>
  </div>
  <!-- End of customer-ratings__content -->
</div>
